<template>
  <sweet-modal width="100%" blocking ref="incomeStatement" class="modal" v-on:close="close">
    <p>{{activeCompanyName}}</p>
    <p>INCOME STATEMENT</p>
    <p>For Period  {{moment(start).format('D MMM YY')}} to {{moment(end).format('D MMM YY')}}</p>
    <el-table
        :data="data"
        stripe
        max-height="500"
        size="small"
        style="width: 100%"
        :tree-props="{ children: 'children' }">
      <el-table-column
          prop="type"
          label="Type">
      </el-table-column>
      <el-table-column
          prop="class"
          label="Class">
      </el-table-column>
      <el-table-column
          prop="group"
          label="Group">
      </el-table-column>
      <el-table-column
          prop="account"
          label="Account">
      </el-table-column>
      <el-table-column
          prop="amount"
          align="right"
          label="Amount">
          <template slot-scope="scope">
            <div>{{formatPrice(scope.row.amount)}}</div>
          </template>
      </el-table-column>
    </el-table>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from "axios";
import moment from "moment";

export default {
  name: "GeneralLedgerIncomeStatement",
  components: {
    SweetModal
  },
  computed: {
    activeCompanyName() {
      return this.$store.state.activeCompanyName
    }
  },
  data() {
    return {
      moment: moment,
      end: '',
      start: '',
      data:[]
    }
  },
  methods: {
    async openModal(start, end, quarterly) {
      try {
        this.start = start;
        this.end = end;
        let url = `/api/v1/income-statement/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}&typeReport=${quarterly ? quarterly : null}`
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(url)
        this.data = data.list
        this.$refs.incomeStatement.open();
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    close() {
      this.end = ''
      this.start = ''
      this.data = []
      this.$parent.filter.datesType = 'None'
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style scoped>

</style>
